import baseApp from '../plugins/baseApp'
import api from '@/api'
import caseApi from '@/api/case'
import teachCenterApi from '@/api/teachCenter'
import courseDetailApi from '@/api/courseDetail'
import teachingCenterList from '@/api/teachingCenterList'
import courseGroupApi from '@/api/courseGroup'
import setup from '@/plugins/permission'
import lectureApi from '@/api/lecture'
import singlePageApi from '@/api/singlePage'
import researchCourseApi from '@/api/researchCourse'
import teachingActivityApi from '@/api/teachingActivity'
import teamBuildingDetail from '@/api/teamBuildingDetail'
import trainingPlanApi from '@/api/trainingPlan'
import planSummaryApi from '@/api/planSummary'
import topicForumApi from '@/api/topicForum'
import teachingCenterApi from '@/api/teachingCenter'
import shareRes from '@/api/shareRes'

export default async function (App) {
  const schoolId = await setup()
  let vm = baseApp(App, schoolId)
  vm.config.globalProperties.$http = {
    ...vm.config.globalProperties.$http,
    ...api,
    ...caseApi,
    ...teachCenterApi,
    ...courseDetailApi,
    ...teachingCenterList,
    ...courseGroupApi,
    ...lectureApi,
    ...singlePageApi,
    ...researchCourseApi,
    ...teachingActivityApi,
    ...teamBuildingDetail,
    ...trainingPlanApi,
    ...planSummaryApi,
    ...topicForumApi,
    ...teachingCenterApi,
    ...shareRes
  }
  // vm.config.globalProperties.$http = { ...vm.config.globalProperties.$http, ...api, nuc }
  vm.config.globalProperties.$schoolUrl = `https://${process.env.VUE_APP_HOST}`
  vm.provide('$schoolId', schoolId).provide('$http', { ...vm.config.globalProperties.$http })

  vm.config.errorHandler = (err, vm, info) => {
    // 处理错误
    // `info` 是 Vue 特定的错误信息，比如错误所在的生命周期钩子
    console.log({ err, vm, info })
    console.log(err.stack)
  }
  return vm
}
